import ficha50 from "@assets/images/lottery-icons/fichas/ficha_50.svg";
import ficha100 from "@assets/images/lottery-icons/fichas/ficha_100.svg";
import ficha500 from "@assets/images/lottery-icons/fichas/ficha_500.svg";
import ficha1000 from "@assets/images/lottery-icons/fichas/ficha_1000.svg";
import ficha5000 from "@assets/images/lottery-icons/fichas/ficha_5000.svg";

export const MIN_BET_AMOUNT = 50;

export const fichas = [
  {value: 50, name: "ficha50", image: ficha50},
  {value: 100, name: "ficha100", image: ficha100},
  {value: 500, name: "ficha500", image: ficha500},
  {value: 1000, name: "ficha1000", image: ficha1000},
  {value: 5000, name: "ficha5000", image: ficha5000},
];

export const MAX_TOTAL_BET = 5000;
